import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createClass from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/inherits.js";
import BpmnRenderer from "bpmn-js/lib/draw/BpmnRenderer";
import { append as svgAppend, create as svgCreate } from "tiny-svg";
var CustomRenderer = /*#__PURE__*/function (_BpmnRenderer) {
  function CustomRenderer(config, eventBus, styles, pathMap, canvas, textRenderer) {
    var _this;
    _classCallCheck(this, CustomRenderer);
    _this = _callSuper(this, CustomRenderer, [config, eventBus, styles, pathMap, canvas, textRenderer, 2000]);
    _this.handlers["user:MySql"] = function (parentGfx, element) {
      var url = "https://hexo-blog-1256114407.cos.ap-shenzhen-fsi.myqcloud.com/rules.png",
        attr = {
          x: 0,
          y: 0,
          width: 48,
          height: 48
        };
      var customIcon = svgCreate("image", _objectSpread(_objectSpread({}, attr), {}, {
        href: url
      }));
      element["width"] = attr.width; // 这里我是取了巧, 直接修改了元素的宽高
      element["height"] = attr.height;
      svgAppend(parentGfx, customIcon);
      return customIcon;
    };
    return _this;
  }
  _inherits(CustomRenderer, _BpmnRenderer);
  return _createClass(CustomRenderer);
}(BpmnRenderer);
export { CustomRenderer as default };